import * as React from "react";
import { MainNavItem } from "src/components/Header/Navbars/Nav/Nav.components";
import {
  NavList,
  StyledNav,
} from "src/components/Header/Navbars/NavbarsSharedComponents";

export interface Props {
  openContactModal: () => void;
}

const Nav: React.FunctionComponent<Props> = ({ openContactModal }) => {
  return (
    <StyledNav>
      <NavList data-cy="menuNavigation">
        <MainNavItem className="text-underlined" onClick={openContactModal}>
          Contact us
        </MainNavItem>
      </NavList>
    </StyledNav>
  );
};

export default Nav;
